import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './common/signin/signin.component';
import { ProgramsListComponent } from './common/programs-list/programs-list.component';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: 'programs',
    component: ProgramsListComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'program-members',
    loadComponent: () =>
      import('./common/program-members/components/program-members.component').then(
        m => m.ProgramMembersComponent
      ),
  },
  {
    path: 'superAdmin',
    loadChildren: () => import('./superadmin/superadmin.routes').then(m => m.superAdminRoutes),
    canActivate: [AuthGuardService],
  },
  {
    path: 'fulfillmentadmin',
    loadChildren: () =>
      import('./fulfillmentadmin/fulfillmentadmin.routes').then(m => m.fulfillmentAdminRoutes),
    canActivate: [AuthGuardService],
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
